/**
 * H4: signposts (ป้าย) at the field and town edges of the 256 m plains: where one stands (metres, the layout's
 * coordinates, data/layouts/plains.ts) and what it reads. Data only; the renderer draws a board by each.
 * TODO-polish: placement against the roads once the sign prop exists; `toward` names a place in AREAS / GATES.
 */
export interface PlainsSign {
  readonly id: string;
  readonly at: readonly [number, number];
  /** The board's text (Thai). */
  readonly text: string;
  /** The place the board points at (an `AREAS` id), if any. */
  readonly toward?: string;
}

export const PLAINS_SIGNS: readonly PlainsSign[] = [
  { id: 'sign-town-north', at: [134, 96], text: 'เขตลานสำนัก · ทางเหนือสู่ทุ่งลมหวน', toward: 'apefield' },
  { id: 'sign-town-west', at: [66, 132], text: 'ขอบย่านบ้านเรือน · ทางตะวันตกสู่วัดร้างระฆังร้าว', toward: 'temple' },
  { id: 'sign-town-east', at: [206, 128], text: 'ปลายถนนตลาด · ทางตะวันออกสู่ผาตะวันออก', toward: 'eastcliff' },
  { id: 'sign-town-south', at: [134, 182], text: 'ท่ารถม้า · ทางใต้สู่นาขั้นบันได', toward: 'farm' },
  { id: 'sign-bamboo', at: [72, 62], text: 'ป่าไผ่เหนือ · ระวังสัตว์ป่า', toward: 'bamboo' },
  { id: 'sign-wood', at: [166, 88], text: 'ป่าต้นน้ำ · ลำธารไหลลงตะวันออก', toward: 'wood' },
  { id: 'sign-marsh', at: [44, 168], text: 'บึงหมอก · พื้นเฉอะแฉะ เดินช้า', toward: 'marsh' },
  { id: 'sign-hill', at: [72, 190], text: 'เนินโจร · นอกเขตปลอดภัย', toward: 'hill' },
  { id: 'sign-graves', at: [176, 204], text: 'สุสานเนินหมอก · ผู้อ่อนฝีมืออย่าเข้า', toward: 'graves' },
  { id: 'sign-redcliff', at: [218, 224], text: 'ผาแดง · ทางแคบเหนือเหว', toward: 'redcliff' },
  { id: 'sign-trainhall', at: [100, 120], text: 'โรงฝึกยุทธ์ · ครูรับศิษย์ทุกวัน', toward: 'trainhall' },
  { id: 'sign-warehouse', at: [160, 124], text: 'โรงคลัง · ฝากของ รับของ', toward: 'market' },
];
